import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  Modal,
  Grid,
  Stack,
  Pagination,
  OutlinedInput,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Checkbox,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

// import DatePicker from "react-datepicker";
import EventIcon from "@mui/icons-material/Event";
import Swal from "sweetalert2";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import { ToFromDate } from "../../common/toFromDate";
import {
  convertDateFormat,
  convertDateToCustomFormat,
  getFirstDateOfCurrentMonthPayloadFormate,
  getLastDateOfCurrentMonthPayloadFormat,
  swalAlertPopProps,
} from "../../utils/commonUtils";
import {
  validationsAdd,
  validationsSave,
} from "../expense/expenceValidationFunction";
import ExpenseModalCard from "../expense/expenseModalCard";
import { totalPriceExpense } from "../expense/expenseFunction";
import { addData, updateBill } from "../expense/expenseCustomApiHandlers";
import { addExpense, updateExpense } from "../expense/expanceApi";

import SearchIcon from "@mui/icons-material/Search";

// import "react-datepicker/dist/react-datepicker.css";
import { getUnpaidUser } from "../paymentReceipt/paymentReceiptApi";
import { getCounterSales } from "./outStandingReportCustomApiHandler";
import {
  GetAssistancePayrollDetail,
  GetAssistancePayrollDetailV2,
  getCounterSalesStatement,
  titleAssistantPayRoll,
} from "./outstandingApi";
import PaymentReceiptSearchModal from "../paymentReceipt/paymentReceiptSearchModal";
import PayrolSearchModal from "./payrollSearchModal";
import EmployeePayrollModalCard from "./employeePayrollModalCard";
import { PaymentmodeModal } from "./paymentmodeModal";
import { ModalHeader } from "../../common/modalHeader";
import { useSelector } from "react-redux";
import { ToFromDateMonth } from "../../common/toDate_month";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { getAllEmpAttendanceMonth } from "../employeeInfo/appoinmentDashboardApi";
// import {

//   swalAlertPopProps,
// } from "../../utils/commonUtils";
export default function EmployeePayRollModal({
  open,
  setOpen,
  getexpence,
  filterByProp,
  setModalData,
  getPurchase,
  idProp,
  expenseItemArrProps,
  updateModalData,
}) {
  const [flagPop, setflagPop] = useState(false);
  const timeoutRef = useRef(null);
  const [pagination, setPagination] = useState({
    page: 1,
    total: 10,
    records: 0,
  });
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const [USerObject, setUSerObject] = useState(null);

  const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);

  const [upPaidBillData, setUnPaidBillData] = useState();
  const [billFilter, setBillFilter] = useState(null);

  const [unPaidBill, setUnPaidBill] = useState([]);
  const data = {
    customerMobile: "",
    amount: 0,
    name: "",
    workingDays: "",
  };

  useEffect(() => {
    console.log(USerObject, "USerObject");
  }, [USerObject]);

  const [payloadGetCounterSales, setPayloadGetCounterSales] = useState({
    page: 1,
    pageSize: pagination.pageSize,
    sortBy: "",
    order: 0,
    buyerGroupId: 0,
    filter: "",
    search: "",
  });
  const [outStandingBills, setOutStandingBills] = useState({
    records: [],
    totalOustandingAmount: "",
    totalRecords: "",
  });
  const getUnpaid = async (param) => {
    await getUnpaidUser(param)
      .then((res) => {
        console.log("unPaid user", res?.data?.data[0]);

        setUnPaidBillData(res?.data?.data[0]);
      })
      .catch((err) => {});
  };

  //   const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [search, setSearch] = useState("");

  const [startDateFormat, setstartDateFormat] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD")
  );

  // const data = {
  //   customerMobile: "",
  // };
  const [billData, setBillData] = useState(data);

  const onClose = () => {
    setOpen(false);
    // setBillData(null);
    console.log("close");
    setExpenseItems(payload);
    setFilterBy("RowMaterial");
    setExpenseItemssArr([]);
    setId();
    setExpenseItems(payload);
    setCounterSalesHeader(null);
    setModalData();
    setSearch("");
    setUSerObject(null);
    setBillData({
      customerMobile: "",
      amount: 0,
      name: "",
      workingDays: "",
      workingType: null,
    });

    // setExpenseItemssArr([]);
    setSelectedStartDate(dayjs());
    setSelectedEndDate(dayjs());
    setDisplayEndDate(null);
    setDate(dayjs().format("MMMM YYYY")); // <-- add this to reset selected month
    setSummary({ totalPresent: 0 }); // <-- reset summary counts
    setSearchOutStandingsModal(false);
  };

  const handleChange = (event, value) => {
    setPagination({
      ...pagination,
      page: value,
    });
  };

  const [searchItem, setSearchItem] = useState([]);

  let payload = {
    amount: 0,
    description: "",
  };
  const [ExpenseItems, setExpenseItems] = useState(payload);

  const stockPayload = {
    page: 1,
    pageSize: 10,
  };

  const [ExpenseItemssArr, setExpenseItemssArr] = useState([]);
  const [id, setId] = useState();

  useEffect(() => {
    if (open === true) {
      const now = dayjs();
      setSelectedStartDate(now);
      setstartDateFormat(now.startOf("month").format("YYYY-MM-DD"));
      setEndDate(now.endOf("month").format("YYYY-MM-DD"));
      setDate(now.format("MMMM YYYY"));

      // Reset everything cleanly
      setBillData({
        customerMobile: "",
        amount: 0,
        name: "",
        workingDays: "",
        workingType: null,
      });

      setCounterSalesHeader(null);
      setUSerObject(null);
      setSummary({ totalPresent: 0 });
    }
  }, [open]);

  const addLeadingZero = (value) => {
    return value < 10 ? "0" + value : value;
  };

  const [date, setDate] = useState(
    (() => {
      var currentDate = new Date();
      let dateContainer = String(currentDate).split(" ");
      var year = dateContainer[2];
      var month = dateContainer[1];
      var day = dateContainer[3];
      var formattedDate =
        year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);

      return formattedDate;
    })()
  );

  useEffect(() => {
    if (updateModalData?.id) {
      setDate(convertDateToCustomFormat(updateModalData?.date?.split("T")[0]));
    }
  }, [updateModalData]);

  useEffect(() => {}, [filterByProp]);
  const [startDate, setStartDate] = useState(new Date());
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const [filters, setFilters] = useState([
    {
      name: "Raw Material",
      value: "Raw material",
    },
    { name: "Salary", value: "Salary" },
    {
      name: "Shop Maintenance",
      value: "Shop Maintenance",
    },
    { name: "Other", value: "Other" },
  ]);
  const [filterBy, setFilterBy] = useState("RowMaterial");
  // const addData = async () => {};

  const [opent, setOpent] = useState(false);
  const [counterSalesHeader, setCounterSalesHeader] = useState(null);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [SelectedStartDate, setSelectedStartDate] = useState(dayjs());
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [SelectedEndDate, setSelectedEndDate] = useState(dayjs());
  const [summary, setSummary] = useState({
    totalPresent: 0,
  });
  const [dataFetched, setDataFetched] = useState(false);

  useEffect(() => {
    if (!startDateFormat)
      setstartDateFormat(getFirstDateOfCurrentMonthPayloadFormate());
    console.log("StartDate=======", startDateFormat);
    if (businessChooseTab?.value == "settledandpaidAmount") {
      setDataFetched(false);
      GetAssistancePayrollDetailV2(
        {
          fromDate: startDateFormat,
          toDate: endDate,
          employeeMasterId: USerObject?.id,
          page: 1,
          pageSize: 1000,
          // workingDays: 0,
        },
        (data) => {
          // console.log("data == ", data);
          setCounterSalesHeader(data?.data);
          setDataFetched(true);
        }
      );
    }
    // else if (businessChooseTab?.value == "Salary") {
    //   let startDate = startDateFormat;
    //   if (/^[A-Za-z]+\s\d{4}$/.test(startDateFormat)) {
    //     startDate = new Date(`${startDateFormat} 01 00:00:00 GMT`);
    //   }
    //   let endDateFormatted = new Date(`${endDate} 00:00:00 GMT`);
    //   console.log("StartDate====", startDate)
    //   GetAssistancePayrollDetailV2(
    //     {
    //       fromDate: startDate,
    //       toDate: endDateFormatted,
    //       employeeMasterId: USerObject?.id,
    //       page: 1,
    //       pageSize: 1000,
    //       workingDays: 0,
    //     },
    //     (data) => {
    //       console.log("data == ", data);
    //       setCounterSalesHeader(data?.data);
    //     }
    //   );
    // }
  }, [businessChooseTab, USerObject]);

  const datePickerOnChange = (newValue) => {
    if (!newValue) return;

    const startOfMonth = newValue.startOf("month").format("YYYY-MM-DD");
    const endOfMonth = newValue.endOf("month").format("YYYY-MM-DD");

    setSelectedStartDate(newValue);
    setstartDateFormat(startOfMonth);
    setEndDate(endOfMonth);

    setDate(newValue.format("MMMM YYYY")); // for display
    setStartDateOpen(false);
  };

  const datePickerOnChangeEnd = (newValue) => {
    setSelectedEndDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDisplayEndDate(formattedDate2);

    // Update endDate for API call
    setEndDate(newValue.format("YYYY-MM-DD"));
    setEndDateOpen(false);
  };
  useEffect(() => {
    if (!open || !businessChooseTab?.value) {
      setCounterSalesHeader(null);
      // setCounterSalesHeader([]);
      setSearch("");
    }
  }, [open, businessChooseTab?.value]);
  useEffect(() => {
    setCounterSalesHeader([]);
  }, [businessChooseTab?.value]);
  useEffect(() => {
    console.log("USerObject changed:", USerObject);
  }, [USerObject]);

  useEffect(() => {
    // return

    // console.log("Total id", USerObject.employeeId);
    // console.log("*******@", employeeId.id);
    // if (!USerObject.employeeId || !SelectedStartDate) return;

    // If no data for this month, fetch from backend
    // if (monthlyAttendance[month]) {
    if (USerObject) {
      const payload = {
        employeeId: Number(USerObject.id),
        fromMonth: dayjs(SelectedStartDate)
          .startOf("month")
          .format("YYYY-MM-DD"),
      };

      getAllEmpAttendanceMonth(payload, (res) => {
        const rawData = res?.data?.data?.records || [];
        const newMonthData = {};

        rawData.forEach(({ forDate, servedStatus }) => {
          const day = dayjs(forDate).date();
          newMonthData[day] = servedStatus;
        });

        // setMonthlyAttendance((prev) => ({
        //   ...prev,
        //   [SelectedStartDate]: newMonthData,
        // }));

        // Optional: store summary counts
        const responseData = res?.data?.data;
        setSummary({
          totalPresent: responseData?.totalPresentDays ?? 0,
        });
        setBillData((prev) => ({
          ...prev,
          workingDays: responseData?.totalPresentDays ?? 0,
          workingType: "auto", // <-- This ensures the checkbox is selected
        }));
        // console.log("Total raw", USerObject);
      });

      // }
    }
  }, [USerObject, SelectedStartDate]);
  console.log("Total attendance", summary.totalPresent);
  useEffect(() => {
    if (
      open &&
      dataFetched &&
      counterSalesHeader &&
      Array.isArray(counterSalesHeader.counterSalesHeader) &&
      counterSalesHeader.counterSalesHeader.length === 0
    ) {
      // if (businessChooseTab?.value === "settledandpaidAmount") return;
      Swal.fire({
        // toast: true,
        // icon: "info",
        // title: "No details found",
        // position: "top-end", // top-right corner
        // showConfirmButton: false,
        // timer: 3000,
        // timerProgressBar: true,
        // didOpen: (toast) => {
        //   toast.style.zIndex = 9999; // ✅ Much higher than MUI modal
        // },
        text: "No details found",
        icon: "info",

        ...swalAlertPopProps,
      });
      onClose();
    }
  }, [counterSalesHeader]);
  return (
    <Modal
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xs"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "70%", md: "60%", lg: "50%", xl: "50%" },

          overflowY: "auto",
          borderRadius: "10px",
          height:
            businessChooseTab?.value === "Salary"
              ? { sm: "78vh", md: "85vh", lg: "80vh", xs: "80vh" }
              : businessChooseTab?.value === "settledandpaidAmount"
              ? { sm: "65vh", md: "68vh", lg: "68vh", xs: "75vh" }
              : { sm: "75vh", md: "80vh", lg: "80vh", xs: "80vh" },
          position: "absolute",
          left: { xs: "2%", sm: "20%", md: "25%", lg: "25%", xl: "25%" },

          top: { xs: "5%", sm: "10%", md: "10%" },
          // top: {sm:"10%", xs:"2%"},
        }}
      >
        <ModalHeader
          title={"Employee Payroll Details"}
          onClose={(data) => {
            setOpen(data);
          }}
        />

        {/* <Divider /> */}
        <Grid container sx={{ position: "relative" }}>
          <Grid item xs={12} sm={12} sx={{ borderRight: "1px solid #dfdfdf" }}>
            <DialogContent sx={{ pr: 2, pt: 2, pb: 0 }}>
              <Grid container item xs={12} spacing={1}>
                {businessChooseTab?.value == "settledandpaidAmount" && (
                  // <Grid item xs={12} sm={6}>
                  //   <TextField
                  //     label="Date"
                  //     size="small"
                  //     value={
                  //       dayjs.isDayjs(SelectedStartDate) &&
                  //       dayjs.isDayjs(SelectedEndDate)
                  //         ? `${SelectedStartDate.format(
                  //             "DD-MM-YYYY"
                  //           )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                  //         : dayjs.isDayjs(SelectedStartDate)
                  //         ? SelectedStartDate.format("DD-MM-YYYY")
                  //         : ""
                  //     }
                  //     id="datepickerfield"
                  //     placeholder="Select date range"
                  //     InputLabelProps={{
                  //       sx: {
                  //         color: "#545454",
                  //         fontWeight: 400,
                  //         fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  //         paddingX: "7px",
                  //       },
                  //     }}
                  //     InputProps={{
                  //       readOnly: true,
                  //       endAdornment: (
                  //         <CalendarMonthIcon
                  //           sx={{
                  //             cursor: "pointer",
                  //             mr: 1,
                  //           }}
                  //           onClick={() => setStartDateOpen(true)} // trigger open
                  //         />
                  //       ),
                  //       sx: {
                  //         background: "#fff",
                  //         borderRadius: 1,
                  //         cursor: "pointer",
                  //         fontFamily: "'Montserrat', sans-serif",
                  //         fontWeight: 500,
                  //       },
                  //     }}
                  //     onClick={() => setStartDateOpen(true)} // trigger open
                  //     sx={{ width: "100%", height: "50px" }}
                  //   />

                  //   <Box sx={{ position: "relative" }}>
                  //     <LocalizationProvider dateAdapter={AdapterDayjs}>
                  //       <DatePicker
                  //         open={startDateOpen}
                  //         onOpen={() => setStartDateOpen(true)}
                  //         onClose={() => setStartDateOpen(false)}
                  //         value={SelectedStartDate}
                  //         InputLabelProps={{
                  //           sx: {
                  //             color: "#545454",
                  //             fontWeight: 400,
                  //             fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  //             paddingX: "7px",
                  //           },
                  //         }}
                  //         onChange={(val) => {
                  //           datePickerOnChange(val);
                  //         }}
                  //         maxDate={SelectedEndDate || undefined}
                  //         slotProps={{
                  //           popper: {
                  //             placement: "bottom-end",
                  //             anchorEl:
                  //               document.querySelector("#datepickerfield"),
                  //             sx: { zIndex: 1500 },
                  //           },
                  //           textField: { style: { display: "none" } },
                  //         }}
                  //       />
                  //     </LocalizationProvider>

                  //     <LocalizationProvider dateAdapter={AdapterDayjs}>
                  //       <DatePicker
                  //         open={endDateOpen}
                  //         onOpen={() => setEndDateOpen(true)}
                  //         onClose={() => setEndDateOpen(false)}
                  //         value={SelectedEndDate}
                  //         onChange={(val) => {
                  //           datePickerOnChangeEnd(val);
                  //         }}
                  //         InputLabelProps={{
                  //           sx: {
                  //             color: "#545454",
                  //             fontWeight: 400,
                  //             fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  //             paddingX: "7px",
                  //           },
                  //         }}
                  //         minDate={SelectedStartDate || undefined}
                  //         slotProps={{
                  //           popper: {
                  //             placement: "bottom-start",
                  //             anchorEl:
                  //               document.querySelector("#datepickerfield"),
                  //             sx: { zIndex: 1500 },
                  //           },
                  //           textField: { style: { display: "none" } },
                  //         }}
                  //       />
                  //     </LocalizationProvider>
                  //   </Box>
                  // </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Date Range"
                      size="small"
                      value={
                        SelectedStartDate && SelectedEndDate
                          ? `${SelectedStartDate.format(
                              "DD-MM-YYYY"
                            )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                          : ""
                      }
                      id="date-range-field"
                      placeholder="Select date range"
                      InputLabelProps={{
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <CalendarMonthIcon
                            sx={{ cursor: "pointer", mr: 1 }}
                            onClick={() => setStartDateOpen(true)} // open both pickers
                          />
                        ),
                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                        },
                      }}
                      onClick={() => setStartDateOpen(true)} // also open on click
                      sx={{ width: "100%", height: "50px" }}
                      inputRef={(el) => (window.dateRangeAnchor = el)}
                    />

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      {/* Start Date Picker */}
                      <DatePicker
                        open={startDateOpen}
                        onClose={() => {
                          setStartDateOpen(false);
                          setTimeout(() => setEndDateOpen(true), 300); // 👈 open end date next
                        }}
                        value={SelectedStartDate}
                        onChange={(newValue) => {
                          if (!newValue) return;
                          setSelectedStartDate(newValue);
                          setstartDateFormat(newValue.format("YYYY-MM-DD"));
                        }}
                        slotProps={{
                          popper: {
                            placement: "bottom-start", // 👈 ensures it opens below
                            anchorEl: () => window.dateRangeAnchor, // 👈 attach popper to field
                            sx: { zIndex: 1500 },
                          },
                          textField: { style: { display: "none" } },
                        }}
                      />

                      {/* End Date Picker */}
                      <DatePicker
                        open={endDateOpen}
                        onClose={() => setEndDateOpen(false)}
                        value={SelectedEndDate}
                        onChange={(newValue) => {
                          if (!newValue) return;
                          setSelectedEndDate(newValue);
                          setEndDate(newValue.format("YYYY-MM-DD"));
                        }}
                        slotProps={{
                          popper: {
                            placement: "bottom-start", // 👈 ensures it opens below
                            anchorEl: () => window.dateRangeAnchor, // 👈 attach popper to field
                            sx: { zIndex: 1500 },
                          },
                          textField: { style: { display: "none" } },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                )}
                {businessChooseTab?.value == "Salary" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Select month"
                      size="small"
                      value={
                        SelectedStartDate
                          ? SelectedStartDate.format("MMMM YYYY")
                          : ""
                      }
                      id="datepickerfield"
                      // placeholder="Select month"
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <CalendarMonthIcon
                            sx={{
                              cursor: "pointer",
                              mr: 1,
                            }}
                            onClick={() => setStartDateOpen(true)} // open picker
                          />
                        ),
                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      onClick={() => setStartDateOpen(true)} // open picker
                      sx={{ width: "100%", height: "50px" }}
                    />

                    <Box sx={{ position: "relative" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          open={startDateOpen}
                          onOpen={() => setStartDateOpen(true)}
                          onClose={() => setStartDateOpen(false)}
                          value={SelectedStartDate}
                          onChange={(val) => {
                            const startOfMonth = val
                              .startOf("month")
                              .format("YYYY-MM-DD");
                            const endOfMonth = val
                              .endOf("month")
                              .format("YYYY-MM-DD");

                            setSelectedStartDate(val);
                            setstartDateFormat(startOfMonth); // e.g., "2026-09-01"
                            setEndDate(endOfMonth); // e.g., "2026-09-30"
                            setDate(val.format("MMMM YYYY")); // optional for display
                            setStartDateOpen(false);
                          }}
                          views={["year", "month"]}
                          slotProps={{
                            popper: {
                              placement: "bottom-end",
                              anchorEl:
                                document.querySelector("#datepickerfield"),
                              sx: { zIndex: 1500 },
                            },
                            textField: { style: { display: "none" } },
                          }}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Grid>
                )}

                <Grid item xs={12} sm={6}>
                  <Box
                    readonly
                    fullWidth
                    onClick={() => {
                      setSearchOutStandingsModal(true);
                    }}
                    sx={{
                      // mt: "12px",
                      display: "flex",
                      height: "20px",
                      justifyContent: "space-between",
                      // width: "70%",
                      border: "2px solid #01008BA8",
                      p: 1,
                      borderRadius: "4px ",
                      fontFamily: "Montserrat",
                      color: "#545454",
                      "&:hover": {
                        cursor: "pointer !important",
                      },
                    }}
                    onChange={(e) => {
                      // setSearch(e.target.value);
                    }}
                  >
                    <Typography
                      variant="p"
                      fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                    >
                      {search !== "" ? search : "Select Employee"}
                    </Typography>
                    <SearchIcon
                      onClick={() => {
                        setSearchOutStandingsModal(true);
                      }}
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        cursor: "pointer",
                        fontSize: { xs: "14px", sm: "14px", md: "15px" },
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>

              {businessChooseTab?.value == "Salary" && (
                <Grid
                  container
                  spacing={2}
                  sx={{
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                  }}
                >
                  <Grid item xs={12} sm={8} md={10}>
                    <Box
                      sx={{
                        border: "1.5px solid #01008B",
                        borderRadius: "8px",
                        p: 1,
                        mt: 2,
                        position: "relative",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          position: "absolute",
                          top: "-16px",
                          left: "12px",
                          backgroundColor: "#fff",
                          px: 1,
                        }}
                      >
                        Working Days
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: {
                            sm: "wrap",
                            md: "nowrap",
                            lg: "nowrap",
                            xl: "nowrap",
                            xs: "wrap",
                          },
                          alignItems: "center",
                          gap: { lg: 0, md: 2, sm: 1, xs: 2 },
                          mt: 2,
                        }}
                      >
                        {/* Auto Option */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            // flex: "1 1 250px",
                          }}
                        >
                          <Checkbox
                            checked={billData.workingType === "auto"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setBillData({
                                  ...billData,
                                  workingDays: summary.totalPresent,
                                  workingType: "auto",
                                });
                              } else {
                                setBillData({
                                  ...billData,
                                  workingType: null,
                                });
                              }
                            }}
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                          />
                          <TextField
                            type="number"
                            size="small"
                            label="Auto"
                            value={summary.totalPresent}
                            InputProps={{ readOnly: true }}
                            sx={{
                              width: {
                                lg: "fit-content",
                                md: "fit-content",
                                sm: 150,
                              },
                            }}
                          />
                        </Box>

                        <Typography
                          sx={{
                            minWidth: "30px",
                            textAlign: "center",
                            alignSelf: "center",
                          }}
                        >
                          or
                        </Typography>

                        {/* Manual Option */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            // flex: "1 1 250px",
                          }}
                        >
                          <Checkbox
                            checked={billData.workingType === "manual"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setBillData({
                                  ...billData,
                                  workingType: "manual",
                                  workingDays: 0,
                                });
                              } else {
                                setBillData({
                                  ...billData,
                                  workingType: null,
                                });
                              }
                            }}
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                          />
                          <TextField
                            type="number"
                            size="small"
                            label="Manual"
                            value={
                              billData?.workingType === "manual"
                                ? billData?.workingDays
                                : 0
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "") {
                                setBillData((prev) => ({
                                  ...prev,
                                  workingDays: "", // store as empty temporarily
                                }));
                                return;
                              }

                              const val = parseInt(value, 10);
                              if (!isNaN(val) && val <= 31) {
                                setBillData((prev) => ({
                                  ...prev,
                                  workingDays: val,
                                }));

                                clearTimeout(timeoutRef.current);
                                timeoutRef.current = setTimeout(() => {
                                  console.log("Manual working days set:", val);
                                }, 1000);
                              }
                            }}
                            sx={{
                              width: {
                                lg: "fit-content",
                                md: "fit-content",
                                sm: 150,
                              },
                              "& input[type=number]": {
                                MozAppearance: "textfield", // Firefox
                              },
                              "& input[type=number]::-webkit-outer-spin-button":
                                {
                                  WebkitAppearance: "none",
                                  margin: 0,
                                },
                              "& input[type=number]::-webkit-inner-spin-button":
                                {
                                  WebkitAppearance: "none",
                                  margin: 0,
                                },
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={4} md={2}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      sx={{
                        mt: { xs: 2, sm: 4 },
                        height: "42px",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                      onClick={() => {
                        if (!startDateFormat)
                          setstartDateFormat(
                            getFirstDateOfCurrentMonthPayloadFormate()
                          );

                        GetAssistancePayrollDetail(
                          {
                            fromDate: startDateFormat,
                            toDate: endDate,
                            employeeMasterId: USerObject?.id,
                            page: 1,
                            pageSize: 1000,
                            workingDays: parseInt(billData.workingDays),
                          },
                          (data) => {
                            console.log("Salary calculation result:", data);
                            setCounterSalesHeader(data?.data);
                          }
                        );
                      }}
                    >
                      Calculate
                    </Button>
                  </Grid>
                </Grid>
              )}

              <Box
                sx={{
                  mb: 1,
                  height: "30vh",
                  overflowY: "scroll",
                  mt: 1,
                }}
              >
                {counterSalesHeader?.counterSalesHeader?.map((item, index) => {
                  return (
                    <EmployeePayrollModalCard
                      date={convertDateToCustomFormat(item?.billDate)}
                      index={index}
                      paymentMode={item?.customer}
                      item={{ ...item, amount: item?.billAmount }}
                      ExpenseItemssArr={ExpenseItemssArr}
                      setExpenseItemssArr={setExpenseItemssArr}
                    />
                  );
                })}
              </Box>

              {counterSalesHeader?.counterSalesHeader?.length > 0 && (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Grid container spacing={{ sm: 2, xs: 0 }}>
                    {/* Left Side */}
                    <Grid item xs={12} sm={6} md={6}>
                      <Grid container>
                        <Grid item xs={8}>
                          <Typography
                            fontWeight="600"
                            color="#01008B"
                            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                          >
                            Total Business
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography
                            fontWeight="500"
                            color="#01008B"
                            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                          >
                            {counterSalesHeader?.counterSalesHeader &&
                            counterSalesHeader?.counterSalesHeader.length > 0 &&
                            counterSalesHeader?.totalSales?.toFixed(2)
                              ? counterSalesHeader?.totalSales?.toFixed(2)
                              : "0.00"}
                          </Typography>
                        </Grid>
                        {businessChooseTab?.value !==
                          "settledandpaidAmount" && (
                          <>
                            {" "}
                            <Grid item xs={8}>
                              <Typography
                                fontWeight="600"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                Raw Material
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                fontWeight="500"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                {counterSalesHeader?.counterSalesHeader &&
                                counterSalesHeader?.counterSalesHeader.length >
                                  0 &&
                                counterSalesHeader.rawMaterialValue.toFixed(2)
                                  ? counterSalesHeader?.rawMaterialValue?.toFixed(
                                      2
                                    )
                                  : "0.00"}
                              </Typography>
                            </Grid>
                          </>
                        )}
                        {/* .....Salary */}
                        {businessChooseTab?.value === "Salary" && (
                          <>
                            {" "}
                            <Grid item xs={8}>
                              <Typography
                                fontWeight="600"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                Salary
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                fontWeight="500"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                {counterSalesHeader?.counterSalesHeader &&
                                counterSalesHeader?.counterSalesHeader.length >
                                  0 &&
                                counterSalesHeader?.salary != null
                                  ? counterSalesHeader.salary.toFixed(2)
                                  : "0.00"
                                  ? counterSalesHeader?.salary?.toFixed(2)
                                  : "0.00"}
                              </Typography>
                            </Grid>
                          </>
                        )}
                        {businessChooseTab?.value !==
                          "settledandpaidAmount" && (
                          <>
                            {" "}
                            <Grid item xs={8}>
                              <Typography
                                fontWeight="600"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                Incentive
                                {/* Amount{" "} */}
                                {/* {businessChooseTab?.value !== "Salary"
                            ? `on ${USerObject?.paymentPercentage ?? "0"}% :`
                            : "0"} */}
                              </Typography>
                            </Grid>
                          </>
                        )}
                        {businessChooseTab?.value !== "Salary" && (
                          <>
                            {" "}
                            <Grid item xs={8}>
                              <Typography
                                fontWeight="600"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                Incentive Amount on 50.0%
                                {/* Amount{" "} */}
                                {/* {businessChooseTab?.value !== "Salary"
                            ? `on ${USerObject?.paymentPercentage ?? "0"}% :`
                            : "0"} */}
                              </Typography>
                            </Grid>
                          </>
                        )}
                        {businessChooseTab?.value !==
                          "settledandpaidAmount" && (
                          <>
                            <Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                fontWeight="500"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                {counterSalesHeader?.counterSalesHeader &&
                                counterSalesHeader?.counterSalesHeader.length >
                                  0 &&
                                counterSalesHeader?.salaryIncentiveAmount?.toFixed(
                                  2
                                )
                                  ? counterSalesHeader?.salaryIncentiveAmount?.toFixed(
                                      2
                                    )
                                  : "0.00"}
                              </Typography>
                            </Grid>
                          </>
                        )}
                        {businessChooseTab?.value !== "Salary" && (
                          <>
                            <Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                fontWeight="500"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                {counterSalesHeader?.counterSalesHeader &&
                                counterSalesHeader?.counterSalesHeader.length >
                                  0 &&
                                counterSalesHeader?.paymentPercentageAmount?.toFixed(
                                  2
                                )
                                  ? counterSalesHeader?.paymentPercentageAmount?.toFixed(
                                      2
                                    )
                                  : "0.00"}
                              </Typography>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Grid>

                    {/* {businessChooseTab?.value == "Salary" && (
                    <>
                      <Grid item xs={8}>
                        <Typography
                          component="span"
                          fontWeight="600"
                          color="#01008B"
                          fontSize= {{ xs: "12px", sm: "13px", md: "15px" }}
                        >
                          Salary
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Box
                          component="span"
                          sx={{
                            fontWeight: "500",
                            color: "#01008B",
                            fontSize: "15px",
                            display: "flex",
                          }}
                        >
                          {counterSalesHeader?.salary.toFixed(2) ?? "0.00"}
                        </Box>
                      </Grid>
                    </>
                  )} */}
                    {/* <Grid item xs={8}>
                    {!counterSalesHeader?.paymentPercentageAmount && (
                      <Typography
                        component="span"
                        fontWeight="bold"
                        color="#bb4a9b"
                      >
                        Incentive
                      </Typography>
                    )}
                    {counterSalesHeader?.paymentPercentageAmount && (
                      <Typography
                        component="span"
                        fontWeight="bold"
                        color="#bb4a9b"
                      >
                        Incentive Amount on
                      </Typography>
                    )}.
                    
                  </Grid> */}
                    {/* <Grid item xs={4}>
                    <Box
                      component="span"
                      sx={{
                        color: "#0da3ca",
                        display: "flex",
                        fontWeight: "600",
                      }}
                    >
                      {counterSalesHeader?.paymentPercentageAmount?.toFixed(
                        2
                      ) ?? "0.00"}
                    </Box>
                  </Grid> */}

                    {/* {businessChooseTab?.value == "Salary" && (
                    <>
                      {" "}
                      <Grid item xs={8}>
                        <Typography
                          component="span"
                          fontWeight="600"
                          color="#01008B"
                          fontSize= {{ xs: "12px", sm: "13px", md: "15px" }}
                        >
                          Allowance
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Box
                          component="span"
                          sx={{
                            color: "#0da3ca",
                            display: "flex",
                            fontWeight: "600",
                          }}
                        >
                          {" "}
                          {counterSalesHeader?.allowances?.toFixed(2) ?? "0.00"}
                        </Box>
                      </Grid>
                    </>
                  )} */}

                    <Grid item xs={12} sm={6} md={6}>
                      <Grid container>
                        {businessChooseTab?.value === "Salary" && (
                          <>
                            <Grid item xs={8}>
                              <Typography
                                fontWeight="600"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                Allowance
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                fontWeight="500"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                {counterSalesHeader?.counterSalesHeader &&
                                counterSalesHeader?.counterSalesHeader.length >
                                  0 &&
                                counterSalesHeader.allowances.toFixed(2)
                                  ? counterSalesHeader?.allowances?.toFixed(2)
                                  : "0.00"}
                              </Typography>
                            </Grid>
                          </>
                        )}
                        {/* /.......... */}
                        <Grid item xs={8}>
                          <Typography
                            fontWeight="600"
                            color="#01008B"
                            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                          >
                            Deduction
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography
                            fontWeight="500"
                            color="#01008B"
                            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                          >
                            {counterSalesHeader?.counterSalesHeader &&
                            counterSalesHeader?.counterSalesHeader.length > 0 &&
                            counterSalesHeader?.deduction?.toFixed(2)
                              ? counterSalesHeader?.deduction?.toFixed(2)
                              : "0.00"}
                          </Typography>
                        </Grid>

                        <Grid item xs={8}>
                          <Typography
                            fontWeight="600"
                            color="#01008B"
                            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                          >
                            Advance
                            {/* Paid - Amount */}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography
                            fontWeight="500"
                            color="#01008B"
                            fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                          >
                            {search &&
                            counterSalesHeader?.counterSalesHeader &&
                            counterSalesHeader?.counterSalesHeader.length > 0 &&
                            counterSalesHeader?.advancePaid?.toFixed(2)
                              ? counterSalesHeader?.advancePaid?.toFixed(2)
                              : "0.00"}
                          </Typography>
                        </Grid>

                        {businessChooseTab?.value === "Salary" && (
                          <>
                            <Grid item xs={8}>
                              <Typography
                                fontWeight="700"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                Net Payable Amount
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Typography
                                fontWeight="500"
                                color="#01008B"
                                fontSize={{
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                }}
                              >
                                {search &&
                                counterSalesHeader?.counterSalesHeader &&
                                counterSalesHeader?.counterSalesHeader.length >
                                  0 &&
                                counterSalesHeader?.netPayableAmount
                                  ? counterSalesHeader.netPayableAmount.toFixed(
                                      2
                                    )
                                  : "0.00"}
                              </Typography>
                            </Grid>
                          </>
                        )}
                        {businessChooseTab?.value ===
                          "settledandpaidAmount" && (
                          <Grid item xs={12}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "end",
                                // alignItems: "center",
                                // mt: 2,
                              }}
                            >
                              <Grid container sx={{ maxWidth: 400 }}>
                                <Grid item xs={10}>
                                  <Typography
                                    fontWeight="600"
                                    color="#01008B"
                                    textAlign={"left"}
                                    fontSize={{
                                      xs: "12px",
                                      sm: "13px",
                                      md: "15px",
                                    }}
                                  >
                                    Net Payable Amount
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={2}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Typography
                                    fontWeight="500"
                                    color="#01008B"
                                    fontSize={{
                                      xs: "12px",
                                      sm: "13px",
                                      md: "15px",
                                    }}
                                  >
                                    {search &&
                                    counterSalesHeader?.counterSalesHeader &&
                                    counterSalesHeader?.counterSalesHeader
                                      .length > 0 &&
                                    counterSalesHeader?.netPayableAmount
                                      ? counterSalesHeader.netPayableAmount.toFixed(
                                          2
                                        )
                                      : "0.00"}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </DialogContent>
          </Grid>
          <Grid container item xs={12}>
            <Grid item xs={12}>
              <Box
                sx={{
                  borderTop: "1px solid #01008B",
                  mt: { sm: 1, xs: 0 },
                  p: 2,
                  // pt: 2,
                  display: "flex",
                  justifyContent: "center",
                  // pb: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    width: "80%",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  disabled={
                    !(
                      counterSalesHeader?.counterSalesHeader &&
                      counterSalesHeader?.counterSalesHeader.length > 0
                    )
                  }
                  onClick={() => {
                    if (!ExpenseItems?.paymentMethod) {
                      setOpent(true);
                      return;
                    }

                    titleAssistantPayRoll(
                      {
                        amount:
                          // counterSalesHeader?.paymentPercentageAmount ??
                          counterSalesHeader?.netPayableAmount ??
                          0,
                        fromDate: startDateFormat,
                        toDate: endDate,
                        employeeMasterId: parseFloat(USerObject?.id),
                        paymentMethod: ExpenseItems?.paymentMethod,
                        transactionDetails: ExpenseItems?.transactionDetails,
                        advancePaid: counterSalesHeader?.advancePaid || 0,
                        deduction: counterSalesHeader?.deduction || 0,
                        paymentPercentageAmount:
                          counterSalesHeader?.paymentPercentageAmount || 0,
                      },
                      () => {
                        setOpent(false);
                        setOpen(false);
                      }
                    );
                  }}
                >
                  Settle Payment and Close
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <PayrolSearchModal
          salaryorPercentage={
            businessChooseTab?.value === "settledandpaidAmount"
              ? false
              : businessChooseTab?.value === "Salary"
              ? true
              : undefined
          }
          searchModal={searchOutStandingsModal}
          setSearchModal={setSearchOutStandingsModal}
          unPaidBill={unPaidBill}
          getUnpaid={getUnpaid}
          setBillData={setBillData}
          search={search}
          setSearch={setSearch}
          setUSerObject={(data) => {
            console.log("data ", data);
            if (billData?.workingDays != "") {
              GetAssistancePayrollDetailV2(
                {
                  fromDate: startDateFormat,
                  toDate: endDate,
                  employeeMasterId: data?.id,
                  page: 1,
                  pageSize: 1000,
                  workingDays: 0,
                },
                (data) => {
                  console.log("data == ", data);
                  setCounterSalesHeader(data?.data);
                }
              );
            }

            setUSerObject(data);
          }}
          setUnPaidBill={setUnPaidBill}
          setUnPaidBillData={setUnPaidBillData}
          setPagination={setPagination}
          billData={billData}
          callSearchApi={(searchName) => {
            setBillFilter("");
            // payloadGetCounterSales.search
            setPayloadGetCounterSales({
              ...payloadGetCounterSales,
              search: "",
            });
            // getCounterSales(
            //   {
            //     page: 1,
            //     pageSize: 10000,
            //     sortBy: "",
            //     order: 0,
            //     buyerGroupId: 0,
            //     filter: "buyername",
            //     search: searchName,
            //   },
            //   outStandingBills,
            //   getCounterSalesStatement,
            //   setNumberOfRecords,
            //   setOutStandingBills
            // );
          }}
          //  userDetail={userDetail}
        />

        <PaymentmodeModal
          callback={(data) => {
            setExpenseItems({ ...ExpenseItems, ...data });
          }}
          open={opent}
          setOpen={setOpent}
        />
      </Box>
    </Modal>
  );
}
